export { useVcardData } from "./useVcardData";
